import React, { useEffect, Suspense, lazy } from 'react';
import { connect } from 'react-redux';
import { checkCookies } from '../../redux/actions/auth';
import asyncComponent from '../common/AsyncComponent';
import { useCookies } from 'react-cookie';
import has from 'lodash-es/has';

const AsyncMobileOnly = lazy(() => import('../common/MobileOnly'));
const AsyncDesktopOnly = lazy(() => import('../common/DesktopOnly'));
const AsyncMobileMenu = asyncComponent(() =>
	import('../moving/MobileMenuModal')
);
const AsyncProgressWizard = asyncComponent(() =>
	import('../common/ProgressWizardModal')
);
const AsyncProgressWizardHourly = asyncComponent(() =>
	import('../common/ProgressWizardHourly')
);
const AsyncInventory = asyncComponent(() =>
	import('../moving/inventory/InventoryModal')
);
const AsyncBook = asyncComponent(() => import('../moving/book/BookModal'));
const AsyncDetails = asyncComponent(() =>
	import('../moving/details/DetailsModal')
);

const mapStateToProps = ({ funnel, movePlan }) => ({
	currentStep: funnel.currentStep,
	isBooked: movePlan
		? movePlan.currentPlan
			? movePlan.currentPlan.is_booked
			: false
		: false,
	showHourly: movePlan
		? movePlan.currentPlan
			? movePlan.currentPlan.hourly_plan
			: false
		: false,
	hourlyRenderLoading: movePlan ? movePlan.hourlyRenderLoading : false,
	hasSelectedMover: has(movePlan.currentPlan, 'mover'),
	isEditInventoryModal: movePlan.isEditInventoryModal,
});

const MovingLayout = props => {
	const [cookies] = useCookies();
	let { checkCookies } = props;

	useEffect(() => {
		checkCookies(cookies);
	}, [checkCookies, cookies]);

	return (
		<>
			{!props.hourlyRenderLoading &&
				(props.showHourly ? (
					<Suspense fallback={''}>
						<AsyncDesktopOnly>
							{props.currentStep !== 'PLAN' &&
								(props.currentStep !== 'INVENTORY' || props.hasSelectedMover) &&
								!props.isBooked &&
								!props.isEditInventoryModal && (
									<Suspense fallback={''}>
										<AsyncProgressWizardHourly />
									</Suspense>
								)}
						</AsyncDesktopOnly>
					</Suspense>
				) : (
					<Suspense fallback={''}>
						<AsyncDesktopOnly>
							{props.currentStep !== 'PLAN' &&
								(props.currentStep !== 'INVENTORY' || props.hasSelectedMover) &&
								!props.isBooked &&
								!props.isEditInventoryModal && (
									<Suspense fallback={''}>
										<AsyncProgressWizard />
									</Suspense>
								)}
						</AsyncDesktopOnly>
					</Suspense>
				))}

			<Suspense fallback={''}>
				<AsyncMobileOnly>
					<Suspense fallback={''}>
						<AsyncMobileMenu />
					</Suspense>
				</AsyncMobileOnly>
			</Suspense>

			<FunnelWrapper
				isBooked={props.isBooked}
				currentStep={props.currentStep}
				hasSelectedMover={props.hasSelectedMover}
				isEditInventoryModal={props.isEditInventoryModal}>
				<FunnelCenterWrapper>
					{!props.showHourly && props.currentStep === 'INVENTORY' && (
						<AsyncInventory />
					)}
					{!props.showHourly && props.currentStep === 'BOOK' && <AsyncBook />}
					{!props.showHourly && props.currentStep === 'DETAILS' && (
						<AsyncDetails />
					)}
				</FunnelCenterWrapper>
			</FunnelWrapper>
		</>
	);
};

const FunnelWrapper = ({
	children,
	isBooked,
	currentStep,
	hasSelectedMover,
	isEditInventoryModal,
}) => {
	return (
		<div className="app-container">
			{children}
			<style jsx>
				{`
					.app-container {
						position: relative;
						height: 100%;
						width: 90%;
						padding-top: ${isBooked
							? '55px;'
							: (currentStep !== 'INVENTORY' || hasSelectedMover) &&
							  !isEditInventoryModal
							? '80px'
							: '0px'};
						display: flex;
						background: white;
					}
					@media only screen and (max-width: 992px) {
						.app-container {
							padding-top: 50px;
						}
					}
				`}
			</style>
		</div>
	);
};

const FunnelCenterWrapper = ({ children }) => (
	<div className="funnel-center-wrapper">
		{children}
		<style jsx>
			{`
				.funnel-center-wrapper {
					background-color: #fff;
					border-bottom: 0px solid #1a3649;
				}
				@media only screen and (max-width: 992px) {
					.funnel-center-wrapper {
						padding-top: 0px;
					}
				}
			`}
		</style>
	</div>
);

// const FunnelRight = ({ children }) => (
//   <>
//     {children}
//     <style jsx>{ ``}</style>
//   </>
// );

export default connect(mapStateToProps, { checkCookies })(MovingLayout);
